import { render } from "./UsersPage.vue?vue&type=template&id=1d48a588&scoped=true"
import script from "./UsersPage.vue?vue&type=script&lang=js"
export * from "./UsersPage.vue?vue&type=script&lang=js"

import "./UsersPage.vue?vue&type=style&index=0&id=1d48a588&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d48a588"]])

export default __exports__